"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditNewPage = exports.FormEditNewPageConfig = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const theme_1 = require("../components/theme");
const mithril_1 = require("../mithril");
const form_designer_1 = require("../modules/form.designer/form.designer");
const services_1 = require("../services");
const form_edit_page_1 = require("./form.edit.page");
const page_1 = require("./page");
const CSS = {
    container: 'c-FormEdit',
};
const Style = {
    [CSS.container]: {
        height: '100%',
        width: '80%',
    },
};
(0, theme_1.addStyles)(Style);
exports.FormEditNewPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formNew,
    path: '/form/new',
    auth: {
        required: true,
    },
};
class FormEditNewPage extends page_1.IkePage {
    constructor() {
        super(exports.FormEditNewPageConfig);
        this.form = null;
        this.designer = null;
    }
    init() {
        var _a, _b;
        const baseForm = core_shared_1.BaseForm.create();
        this.form = baseForm.form;
        this.form.Mutator.displayName(`Base Form - ${(_b = (_a = services_1.Services.Department.current) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : ''}`);
        this.form.Mutator.description('The default Base Form');
        this.designer = new form_designer_1.FormDesigner();
        this.designer.setEditing(true);
        this.designer.isNewForm = true;
        this.designer.setForm(this.form);
    }
    get nodes() {
        var _a;
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (this.designer == null) {
            this.init();
        }
        if (!services_1.Services.User.current) {
            return null;
        }
        const userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
        if (!userProfile || !services_1.Services.UserProfile.canEditForms(userProfile)) {
            return null;
        }
        return (0, mithril_1.m)('div', { className: `${form_edit_page_1.CSS.container} ${CSS.container}`, key: 'new-form' }, (_a = this.designer) === null || _a === void 0 ? void 0 : _a.view());
    }
    onRemove() {
        if (this.designer != null) {
            this.designer.onRemove();
            this.designer = null;
        }
    }
}
exports.FormEditNewPage = FormEditNewPage;
tslib_1.__decorate([
    mobx_1.observable.ref
], FormEditNewPage.prototype, "designer", void 0);
//# sourceMappingURL=form.edit.new.page.js.map